import React from 'react';
import './detail-panel.css';

export default function DetailSection({
  title,
  description,
  extra,
  children,
  className = '',
}) {
  return (
    <section className={`detail-section ${className}`.trim()}>
      {title || extra ? (
        <div className="detail-section-header">
          <div>
            {title ? <div className="detail-section-title">{title}</div> : null}
            {description ? (
              <div className="detail-section-description">{description}</div>
            ) : null}
          </div>
          {extra ? <div className="detail-section-extra">{extra}</div> : null}
        </div>
      ) : null}
      {children}
    </section>
  );
}
